package ch.wsl.typings.choicesJs

import ch.wsl.typings.std.Record
import org.scalablytyped.runtime.StObject
import scala.scalajs.js
import scala.scalajs.js.`|`
import scala.scalajs.js.annotation.{JSGlobalScope, JSGlobal, JSImport, JSName, JSBracketAccess}

object publicTypesSrcScriptsInterfacesChoiceMod {
  
  @js.native
  trait Choice extends StObject {
    
    var active: js.UndefOr[Boolean] = js.native
    
    var choices: js.UndefOr[js.Array[Choice]] = js.native
    
    var customProperties: js.UndefOr[Record[String, Any]] = js.native
    
    var disabled: js.UndefOr[Boolean] = js.native
    
    var elementId: js.UndefOr[Double] = js.native
    
    var groupId: js.UndefOr[Double] = js.native
    
    var id: js.UndefOr[Double] = js.native
    
    var keyCode: js.UndefOr[Double] = js.native
    
    var label: String = js.native
    
    var placeholder: js.UndefOr[Boolean] = js.native
    
    var score: js.UndefOr[Double] = js.native
    
    var selected: js.UndefOr[Boolean] = js.native
    
    var value: Any = js.native
  }
  object Choice {
    
    @scala.inline
    def apply(label: String, value: Any): Choice = {
      val __obj = js.Dynamic.literal(label = label.asInstanceOf[js.Any], value = value.asInstanceOf[js.Any])
      __obj.asInstanceOf[Choice]
    }
    
    @scala.inline
    implicit class MutableBuilder[Self <: Choice] (val x: Self) extends AnyVal {
      
      @scala.inline
      def setActive(value: Boolean): Self = StObject.set(x, "active", value.asInstanceOf[js.Any])
      
      @scala.inline
      def setActiveUndefined: Self = StObject.set(x, "active", js.undefined)
      
      @scala.inline
      def setChoices(value: js.Array[Choice]): Self = StObject.set(x, "choices", value.asInstanceOf[js.Any])
      
      @scala.inline
      def setChoicesUndefined: Self = StObject.set(x, "choices", js.undefined)
      
      @scala.inline
      def setChoicesVarargs(value: Choice*): Self = StObject.set(x, "choices", js.Array(value :_*))
      
      @scala.inline
      def setCustomProperties(value: Record[String, Any]): Self = StObject.set(x, "customProperties", value.asInstanceOf[js.Any])
      
      @scala.inline
      def setCustomPropertiesUndefined: Self = StObject.set(x, "customProperties", js.undefined)
      
      @scala.inline
      def setDisabled(value: Boolean): Self = StObject.set(x, "disabled", value.asInstanceOf[js.Any])
      
      @scala.inline
      def setDisabledUndefined: Self = StObject.set(x, "disabled", js.undefined)
      
      @scala.inline
      def setElementId(value: Double): Self = StObject.set(x, "elementId", value.asInstanceOf[js.Any])
      
      @scala.inline
      def setElementIdUndefined: Self = StObject.set(x, "elementId", js.undefined)
      
      @scala.inline
      def setGroupId(value: Double): Self = StObject.set(x, "groupId", value.asInstanceOf[js.Any])
      
      @scala.inline
      def setGroupIdUndefined: Self = StObject.set(x, "groupId", js.undefined)
      
      @scala.inline
      def setId(value: Double): Self = StObject.set(x, "id", value.asInstanceOf[js.Any])
      
      @scala.inline
      def setIdUndefined: Self = StObject.set(x, "id", js.undefined)
      
      @scala.inline
      def setKeyCode(value: Double): Self = StObject.set(x, "keyCode", value.asInstanceOf[js.Any])
      
      @scala.inline
      def setKeyCodeUndefined: Self = StObject.set(x, "keyCode", js.undefined)
      
      @scala.inline
      def setLabel(value: String): Self = StObject.set(x, "label", value.asInstanceOf[js.Any])
      
      @scala.inline
      def setPlaceholder(value: Boolean): Self = StObject.set(x, "placeholder", value.asInstanceOf[js.Any])
      
      @scala.inline
      def setPlaceholderUndefined: Self = StObject.set(x, "placeholder", js.undefined)
      
      @scala.inline
      def setScore(value: Double): Self = StObject.set(x, "score", value.asInstanceOf[js.Any])
      
      @scala.inline
      def setScoreUndefined: Self = StObject.set(x, "score", js.undefined)
      
      @scala.inline
      def setSelected(value: Boolean): Self = StObject.set(x, "selected", value.asInstanceOf[js.Any])
      
      @scala.inline
      def setSelectedUndefined: Self = StObject.set(x, "selected", js.undefined)
      
      @scala.inline
      def setValue(value: Any): Self = StObject.set(x, "value", value.asInstanceOf[js.Any])
    }
  }
}
